import request from '@/utils/http'
import type { FilterType } from '@/views/common/filtrate/filtrate.type'
// 机经题库列表父类列表

import { ElMessageBox } from 'element-plus'
import { defineStore } from 'pinia'
import { ref } from 'vue'

export const useConfigStore = defineStore(
  'config',
  () => {
    const oneWordPopup = ref(false)
    const open = () => {
      if (oneWordPopup.value) return
      const img = new URL(`@/assets/images/config/yjhms@2x.png`, import.meta.url).href

      ElMessageBox.alert(
        `<div>
          <p style="font-size: var(--el-font-size-large);">点击想选句子首位和末尾单词进行练习，最少选10个词</p>
          <img style="width:100%;display:block;margin-top: 25px;" src="${img}" />
        </div>`,
        '一句话模式使用',
        {
          showConfirmButton: false,
          dangerouslyUseHTMLString: true,
          customStyle: {
            width: '600px',
            maxWidth: '600px',
            borderRadius: '20px'
          },
          callback: () => {
            oneWordPopup.value = true
          }
        }
      )
    }
    // 收藏夹颜色
    const ytCollect: { color: 1 | 2 | 3 | 4; className: string }[] = [
      {
        color: 1,
        className: 'color-1'
      },
      {
        color: 2,
        className: 'color-2'
      },
      {
        color: 3,
        className: 'color-3'
      },
      {
        color: 4,
        className: 'color-4'
      }
    ]
    // 筛选条件
    const filters = ref<FilterType[]>([
      // 新更
      {
        list: [
          {
            value: 0,
            title: '全部'
          },
          {
            value: 1,
            title: '七日内新/更'
          }
        ],
        type: 'updTopic',
        title: '更新',
        value: '',
        hide: true
      },
      // 完整度
      {
        list: [
          {
            value: 0,
            title: '全部',
            // 「全部」即默认态：选中后触发器恢复胶囊样式，不展示可删除 chip
            isDefault: true
          },
          {
            value: 1,
            title: '完整'
          },
          {
            value: 2,
            title: '不完整'
          }
        ],
        value: '',
        type: 'isFull',
        title: '完整',
        alias: '完整度'
      },
      // 类型状态
      {
        list: [
          {
            value: 0,
            title: '全部'
          },
          {
            value: 1,
            title: '已练习'
          },
          {
            value: 2,
            title: '未练习'
          }
        ],
        value: '',
        type: 'practiceStatus',
        title: '练习'
      },

      // 高低频
      {
        list: [
          {
            value: 1,
            title: '高低频'
          },
          {
            value: 4,
            title: '高频'
          },
          {
            value: 5,
            title: '非高频'
          }
        ],
        value: '',
        type: 'type',
        title: '高低频'
      },
      // 收藏
      {
        list: [
          {
            value: '',
            title: '全部'
          },
          {
            value: -1,
            title: '全部收藏'
          },
          {
            value: 1,
            title: '红色'
          },
          {
            value: 2,
            title: '黄色'
          },
          {
            value: 3,
            title: '绿色'
          },
          {
            value: 4,
            title: '蓝色'
          }
        ],
        value: '',
        type: 'color',
        title: '收藏'
      },
      // 热度排序
      {
        list: [
          {
            value: 0,
            title: '默认'
          },
          {
            value: 1,
            title: '热度降序'
          },
          {
            value: 2,
            title: '热度升序'
          }
        ],
        value: '',
        type: 'hotSort',
        title: '题目热度'
      }
    ])
    const wxInfo = ref<NewWxInfo>({
      qrCode: '',
      type: 0,
      wx: '',
      wxImgQr: ''
    })
    /**
     * 获取回流二维码
     * @returns NewWxInfo
     */
    const getNewWxInfoApi = () => {
      return request.get<NewWxInfo>('/api/program/getNewWxInfo').then((res) => {
        wxInfo.value = res.data
        return wxInfo.value
      })
    }

    const showInteract = ref(false)

    return {
      oneWordPopup,
      ytCollect,
      open,
      wxInfo,
      filters,
      getNewWxInfoApi,
      showInteract
    }
  },
  {
    persist: {
      storage: localStorage,
      paths: ['oneWordPopup', 'showInteract']
    }
  }
)

export interface NewWxInfo {
  qrCode: string
  /**类型 1轮换 2企业微信 3小程序菊花码 */
  type: number
  wx: string
  wxImgQr: string
}
